import { ErrorMessage, Field, FieldArray, Formik, FormikProvider, useFormik } from "formik";
import { debounce, initial, set } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Form, FormFeedback, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner, Table, Toast, ToastBody, ToastHeader } from "reactstrap";
import './CommandeLine.css';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaBox, FaBoxes, FaCog, FaEdit, FaImage, FaList, FaMoneyBillWave, FaPlus, FaSave, FaSearch, FaTag, FaTh, FaTimes, FaTrash, FaWarehouse } from "react-icons/fa";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { supplierActions } from "../../sagas/supplierSlice";
import Swal from "sweetalert2";
import { productActions } from "../../sagas/productSlice";
import config from "../../helpers/config";
import { formatPrice, getPrixAchat, preventScroll } from "../../helpers/utility";
import Select from 'react-select';
import * as Yup from 'yup';
import { useNavigate } from "react-router-dom";
import productService from "../../services/productService";
import { categoryActions } from "../../sagas/categorySlice";

const ReceptionLines = ({ formik }) => {
    const { values, setFieldValue } = formik;
    const [items, setItems] = useState([]);
    const [productModal, setProductModal] = useState(false);
    const toggleProductModal = () => setProductModal(!productModal);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [chooseProductModal, setChooseProductModal] = useState(false);
    const toggleChooseProductModal = () => setChooseProductModal(!chooseProductModal);
    const [modalSearchTerm, setModalSearchTerm] = useState('');
    const [displayMode, setDisplayMode] = useState('table');
    const { list } = useSelector(statut => statut.categories); // Assuming you have a Redux store with categories

    const TVA_OPTIONS = [
        { code: 0.2, libelle: '20%' },
        { code: 0.1, libelle: '10%' },
        { code: 0.01, libelle: '7%' },
        { code: 0.14, libelle: '14%' }
    ];

    const ArticleSchema = Yup.object().shape({
        libelle: Yup.string()
            .required('Le libellé est obligatoire')
            .max(200, '200 caractères maximum'),
        categorie: Yup.number()
            .required('La catégorie est obligatoire'),
        unite: Yup.string().required("L'unité est obligatoire"),
        prixAchatTTC: Yup.number()
            .min(0, 'Le prix doit être positif')
            .required('Le prix d\'achat est obligatoire'),
        tauxTVAAchat: Yup.number()
            .min(0, 'Le taux doit être positif')
            .max(1, 'Le taux doit être inférieur à 1')
            .required('Le taux de TVA est obligatoire'),
        prixVenteTTC1: Yup.number()
            .min(0, 'Le prix doit être positif')
            .required('Le prix de vente est obligatoire'),
        stockMinimal: Yup.number()
            .min(0, 'Le stock doit être positif'),
        stockPhysique: Yup.number()
            .min(0, 'Le stock doit être positif')
    });
    const unites = useSelector(statut => statut.products.unites); // Assuming you have a Redux store with unites

    const initialValues = {
        code: '',
        codeBarre: '',
        libelle: '',
        typeArticle: 'STOCKABLE',
        categorie: null,
        unite: null,
        prixAchatTTC: 0,
        tauxTVAAchat: 0.20,
        tauxTVAVente: 0.20,
        prixVenteTTC1: 0,
        prixVenteTTC2: 0,
        prixVenteTTC3: 0,
        stockMinimal: 0,
        stockPhysique: 0,
        stockDisponible: 0,
        enStock: true,
        actif: true,
        photo: null// Initialize photo to null
    };

    const {
        products,
        loading,
        totalPages,
        totalElements,
        pageNumber,
        pageSize,
        error,
    } = useSelector((statut) => statut.products);


    const dispatch = useDispatch();
    const [isSearching, setIsSearching] = useState(false);


    useEffect(() => {
        console.log(values)
        setItems(values.lignes);
        dispatch(productActions.findAllUnites());
        dispatch(categoryActions.list({ query: '' })); // Fetch categories if needed

    }, [values.lignes]);

    useEffect(() => {
        dispatch(productActions.findAll({
            search: searchTerm,
            page: currentPage - 1,
            size: 10,
        }));

    }, [currentPage, chooseProductModal]);


    const handleInputChange = (index, event) => {
        const newItems = [...items];
        const updatedItem = { ...newItems[index], [event.target.name]: event.target.value };
        newItems[index] = updatedItem;

        // Ensure correct numeric values
        const quantity = parseFloat(newItems[index].quantiteRecue) || 0;
        const unitPriceTTC = parseFloat(newItems[index].prixUnitaireTTC) || 0;
        const tauxTVA = (parseFloat(newItems[index].tauxTVA) || 0); // TVA in %

        // --- Correct calculations ---
        const unitPriceHT = unitPriceTTC / (1 + tauxTVA);
        const montantHT = quantity * unitPriceHT.toFixed(2);
        const montantTTC = quantity * unitPriceTTC;

        // Update item
        newItems[index].prixUnitaireHT = Number(unitPriceHT.toFixed(2));
        newItems[index].montantHT = Number(montantHT.toFixed(2));
        newItems[index].montantTTC = Number(montantTTC.toFixed(2));

        // --- Cumulative totals ---
        let htCumul = 0;
        let ttcCumul = 0;
        let totalTaxe = 0;

        newItems.forEach(item => {
            const qte = parseFloat(item.quantiteRecue) || 0;
            const pHT = parseFloat(item.prixUnitaireHT) || 0;
            const tvaRate = (parseFloat(item.tauxTVA) || 0);

            const itemHT = item.montantHT;
            const itemTTC = item.montantTTC;
            const itemTVA = item.montantTTC - item.montantHT;

            htCumul += itemHT;
            ttcCumul += itemTTC;
            totalTaxe += itemTVA;
        });

        // Update formik
        setItems(newItems);
        setFieldValue("lignes", newItems);
        setFieldValue("montantTotalHT", Number(htCumul.toFixed(2)));
        setFieldValue("montantTotalTaxe", Number(totalTaxe.toFixed(2)));
        setFieldValue("montantTotalTTC", Number(ttcCumul.toFixed(2)));
    };


    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const DisplayToggle = () => (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="btn-group">
                <Button
                    color={displayMode === 'table' ? 'primary' : 'light'}
                    onClick={() => setDisplayMode('table')}
                    size="sm"
                >
                    <FaList className="me-1" /> {t('common.table')}
                </Button>
                <Button
                    color={displayMode === 'card' ? 'primary' : 'light'}
                    onClick={() => setDisplayMode('card')}
                    size="sm"
                >
                    <FaTh className="me-1" /> {t('common.cards')}
                </Button>
            </div>

            <div className="d-flex align-items-center gap-3">
                <small className="text-muted">
                    {t('product.showing', {
                        start: (currentPage - 1) * pageSize + 1,
                        end: Math.min(currentPage * pageSize, totalElements),
                        total: totalElements,
                        currentPage: currentPage,
                        totalPages: totalPages
                    })}
                </small>

                <div className="d-flex align-items-center gap-2">
                    <Button color="light" size="sm" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
                        <FaAngleDoubleLeft />
                    </Button>
                    <Button color="light" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        <FaAngleLeft />
                    </Button>

                    <span className="mx-2">
                        {currentPage} / {totalPages}
                    </span>

                    <Button color="light" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        <FaAngleRight />
                    </Button>
                    <Button color="light" size="sm" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
                        <FaAngleDoubleRight />
                    </Button>
                </div>
            </div>
        </div>
    );


    const handleDeleteItem = (index) => {
        const newItems = [...items];
        newItems.splice(index, 1);

        // Update items in formik
        setItems(newItems);
        setFieldValue("lignes", newItems);

        // --- Recalculate totals after deletion ---
        let htCumul = 0;
        let ttcCumul = 0;
        let totalTaxe = 0;

        newItems.forEach(item => {
            const itemHT = item.montantHT;
            const itemTTC = item.montantTTC;
            const itemTVA = item.montantTTC - item.montantHT;

            htCumul += itemHT;
            totalTaxe += itemTVA;
            ttcCumul += itemTTC;
        });

        setFieldValue("montantTotalHT", Number(htCumul.toFixed(2)));
        setFieldValue("montantTotalTaxe", Number(totalTaxe.toFixed(2)));
        setFieldValue("montantTotalTTC", Number(ttcCumul.toFixed(2)));
    };


    const debouncedModalSearch = useCallback(
        debounce((query) => {
            setIsSearching(true);
            dispatch(productActions.findAll({
                search: query,
                page: 0,
                size: pageSize,
                onSuccess: () => setIsSearching(false)
            }));
            setIsSearching(false);
        }, 1000), // Wait 1 second after user stops typing
        [modalSearchTerm]
    );


    // Handle modal search input change
    const handleModalSearchChange = (e) => {
        const value = e.target.value;
        setModalSearchTerm(value);
        debouncedModalSearch(value);
    };

    const handleProductSelect = async (product) => {

        // --- 1. Supplier selection check ---
        if (!values.fournisseurId) {
            Swal.fire({
                icon: 'warning',
                title: t('purchase.noSupplierTitle'),
                text: t('purchase.noSupplierMessage'),
                confirmButtonText: t('common.ok')
            });
            setModalSearchTerm('');
            toggleChooseProductModal();
            return;
        }

        // --- 2. Check duplicate product ---
        const productExists = items.some(item => item.articleId === product.id);
        if (productExists) {
            Swal.fire({
                icon: 'warning',
                title: t('purchase.productExistsTitle'),
                text: t('purchase.productExistsMessage'),
                confirmButtonText: t('common.ok')
            });
            return;
        }

        // --- 3. Fetch supplier price ---
        const supplierId = values.fournisseurId;
        let supplierPrice = 0;

        try {
            supplierPrice = await productService.findPrixAchat(product.id, supplierId);
        } catch (error) {
            console.error("Error getting supplier price:", error);
        }

        // Safety: ensure numeric
        supplierPrice = parseFloat(supplierPrice) || 0;

        const tvaRate = (parseFloat(product.tauxTVAAchat) || 0) / 100; // TVA in %

        // --- 4. Compute HT / TTC correctly ---
        const qty = 1;
        const prixHT = supplierPrice;
        const prixTTC = prixHT * (1 + tvaRate);

        const montantHT = prixHT * qty;
        const montantTTC = montantHT * (1 + tvaRate);
        const montantTVA = montantHT * tvaRate;

        // --- 5. Add new item ---
        const newItem = {
            articleId: product.id,
            articleNom: product.libelle,
            unite: product.unite,
            quantiteRecue: qty,
            prixUnitaireHT: Number(prixHT.toFixed(2)),
            prixUnitaireTTC: Number(prixTTC.toFixed(2)),
            tauxTVA: parseFloat(product.tauxTVAAchat) || 0, // store original %
            montantHT: Number(montantHT.toFixed(2)),
            montantTTC: Number(montantTTC.toFixed(2))
        };

        const newItems = [...items, newItem];

        setItems(newItems);
        setFieldValue("lignes", newItems);

        // --- 6. Recalculate totals ---
        let htCumul = 0;
        let ttcCumul = 0;
        let totalTaxe = 0;

        newItems.forEach(item => {
            const qte = parseFloat(item.quantiteRecue) || 0;
            const pHT = parseFloat(item.prixUnitaireHT) || 0;
            const tva = (parseFloat(item.tauxTVA) || 0) / 100;

            const itemHT = qte * pHT;
            const itemTVA = itemHT * tva;
            const itemTTC = itemHT + itemTVA;

            htCumul += itemHT;
            totalTaxe += itemTVA;
            ttcCumul += itemTTC;
        });

        setFieldValue("montantTotalHT", Number(htCumul.toFixed(2)));
        setFieldValue("montantTotalTaxe", Number(totalTaxe.toFixed(2)));
        setFieldValue("montantTotalTTC", Number(ttcCumul.toFixed(2)));

        // --- 7. Close modal ---
        setModalSearchTerm('');
        toggleChooseProductModal();
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            console.log('Article à enregistrer :', values);

            // Create FormData object
            const formData = new FormData();

            // Map form values to the ArticleDTO structure
            const articleDTO = {
                code: values.code,
                libelle: values.libelle,
                typeArticle: values.typeArticle,
                codeBarre: values.codeBarre,
                categorieId: values.categorie, // Assuming `categorie` is the ID
                unite: values.unite, // Assuming `unite` is the code
                prixAchatTTC: values.prixAchatTTC,
                tauxTVAAchat: values.tauxTVAAchat,
                prixVenteTTC1: values.prixVenteTTC1,
                prixVenteTTC2: values.prixVenteTTC2,
                prixVenteTTC3: values.prixVenteTTC3,
                tauxTVAVente: values.tauxTVAVente,
                stockMinimal: values.stockMinimal,
                stockPhysique: values.stockPhysique,
                stockDisponible: values.stockDisponible,
                enStock: values.enStock,
                actif: values.actif
            };

            // Add the article as a JSON string
            //formData.append('article', JSON.stringify(articleDTO));
            formData.append('article', new Blob([JSON.stringify(articleDTO)], {
                type: 'application/json'
            }));
            // Add the photo if it exists
            if (values.photo) {
                formData.append('photo', values.photo);
            }

            // Prepare the payload

            let payload = {
                formData,
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Succès',
                        text: 'Article enregistré avec succès !',
                        confirmButtonText: 'OK'
                    });
                    resetForm();
                    toggleProductModal();
                }
            };

            // Dispatch the action to save the article
            dispatch(productActions.addProduct(payload));

        } catch (error) {
            console.error('Erreur lors de l\'enregistrement :', error);
            Swal.fire({
                icon: 'error',
                title: 'Erreur',
                text: 'Une erreur est survenue lors de l\'enregistrement de l\'article.',
                confirmButtonText: 'OK'
            });
        } finally {
            setSubmitting(false);
        }
    };

    const formikp = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: ArticleSchema,
        onSubmit: handleSubmit
    });

    const TableView = () => (
        <>
            <div className="cart-container" style={{
                height: '300px',
                overflowY: 'auto'
            }}>

                <Table hover bordered className="align-middle mb-0">
                    <thead className="bg-light">
                        <tr>
                            <th className="align-middle">
                                <FaBarcode className="me-2 text-primary" size={12} />
                                {t('product.code')}
                            </th>
                            <th className="align-middle">
                                <FaBox className="me-2 text-primary" size={12} />
                                {t('product.description')}
                            </th>
                            <th className="align-middle text-end">
                                <FaTag className="me-2 text-primary" size={12} />
                                {t('product.salePrice')}
                            </th>
                            {/* <th className="align-middle text-end">
                                <FaTag className="me-2 text-primary" size={12} />
                                {t('product.buyingPrice')}
                            </th> */}
                            <th className="align-middle text-center">
                                <FaBoxes className="me-2 text-primary" size={12} />
                                {t('product.stockPhysique')}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {!products || products.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center py-4">
                                    <div className="text-muted">
                                        {t('product.noProducts')}
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            products.map((product) => (
                                <tr key={product.id} onClick={() => handleProductSelect(product)}>
                                    <td className="align-middle">{product.code}</td>
                                    <td className="align-middle">
                                        {product.libelle}
                                    </td>
                                    <td className="align-middle text-end">
                                        {formatPrice(product.prixVenteTTC1)}
                                    </td>
                                    {/* <td className="align-middle text-end">{formatPrice(product.prixAchatTTC)}</td> */}
                                    <td className="align-middle text-center">{product.stockPhysique}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
                <small className="text-muted">
                    {t('product.showing', {
                        start: (currentPage - 1) * pageSize + 1,
                        end: Math.min(currentPage * pageSize, totalElements),
                        total: totalElements,
                        currentPage: currentPage,
                        totalPages: totalPages
                    })}
                </small>
            </div>
        </>
    );

    const CardView = () => (
        <div className="card-container" style={{ height: '400px', overflowY: 'auto' }}>
            <Row xs={2} md={3} lg={3} className="g-3">
                {(!products || products.length === 0) && (
                    <Col xs={12} className="text-center py-4 ">
                        {t('product.noProducts')}
                    </Col>
                )}
                {products.map(product => (
                    <Col key={product.id}>
                        <Card className="product-card rounded border shadow-sm" onClick={() => handleProductSelect(product)}>
                            <div className="card-image-container">
                                {product.photo ? (
                                    <img
                                        src={`${config.baseURL}${product.photo}`}
                                        alt={product.libelle}
                                        className="card-img-top rounded-top"
                                    />
                                ) : (
                                    <div className="bg-placeholder rounded-top d-flex align-items-center justify-content-center">
                                        <FaImage size={32} className="text-muted" />
                                    </div>
                                )}
                            </div>
                            <CardBody className="d-flex flex-column">
                                <div className="d-flex justify-content-between align-items-start">
                                    <h6 className="product-title mb-2">
                                        {product.libelle}
                                    </h6>
                                </div>
                                {product.unite ? `${formatPrice(product.prixVenteTTC1)} / ${product.unite}` : 'N/A'}
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );

    return (
        <Container fluid>
            <Table bordered>
                <thead>
                    <tr>
                        <th>{t('purchase.product')}</th>
                        <th>{t('reception.receivedQuantity')}</th>
                        <th>{t('devis.unite')}</th>
                        <th>{t('purchase.unitPriceTTC')}</th>
                        <th>{t('purchase.unitPriceHT')}</th>
                        <th>{t('purchase.montantHT')}</th>
                        <th>{t('purchase.tauxTVA')}</th>
                        <th>{t('purchase.montantTTC')}</th>
                        <th>{t('common.actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {items.length === 0 ? (
                        <tr>
                            <td colSpan="9" className="text-center py-4">
                                <div className="text-muted">
                                    {t('purchase.noItems')}

                                </div>
                            </td>
                        </tr>
                    ) : (
                        items.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <Input
                                        type="text"
                                        name="articleNom"
                                        value={item.articleNom}
                                        onChange={(event) => handleInputChange(index, event)}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <Input
                                        type="number"
                                        onFocus={(e) => {
                                            e.target.select();
                                            e.target.addEventListener('wheel', preventScroll, { passive: false });
                                        }}
                                        onBlur={(e) => {
                                            e.target.removeEventListener('wheel', preventScroll);
                                        }}
                                        className="no-spinner"
                                        name="quantiteRecue"
                                        value={item.quantiteRecue}
                                        onChange={(event) => handleInputChange(index, event)}
                                        disabled={values.statut !== 'EN_ATTENTE'}
                                    />
                                </td>
                                <td>
                                    <Input
                                        type="text"
                                        name="unite"
                                        value={unites.find(u => u.code === item.unite)?.libelle || item.unite}
                                        disabled
                                    />
                                </td>
                                <Input
                                    type="number"
                                    onFocus={(e) => {
                                        e.target.select();
                                        e.target.addEventListener('wheel', preventScroll, { passive: false });
                                    }}
                                    onBlur={(e) => {
                                        e.target.removeEventListener('wheel', preventScroll);
                                    }}
                                    className="no-spinner"
                                    name="prixUnitaireTTC"
                                    value={item.prixUnitaireTTC}
                                    onChange={(event) => handleInputChange(index, event)}
                                    disabled={values.statut !== 'EN_ATTENTE'}
                                />
                                <td>
                                    <Input
                                        type="number"
                                        onFocus={(e) => e.target.select()} // Select the field content on focus
                                        name="prixUnitaireHT"
                                        value={item.prixUnitaireHT}
                                        onChange={(event) => handleInputChange(index, event)}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <Input
                                        type="number"
                                        onFocus={(e) => e.target.select()} // Select the field content on focus
                                        name="montantHT"
                                        value={item.montantHT}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <Input
                                        type="select"
                                        name="tauxTVA"
                                        onChange={(event) => handleInputChange(index, event)}
                                        value={item.tauxTVA}
                                    >
                                        {TVA_OPTIONS.map(option => (
                                            <option key={option.code} value={option.code}>
                                                {option.libelle}
                                            </option>
                                        ))}
                                    </Input>
                                </td>
                                <td>
                                    <Input
                                        type="text"
                                        name="montantTTC"
                                        value={formatPrice(item.montantTTC, false)}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <Button color="danger" onClick={() => handleDeleteItem(index)} size="sm"
                                        disabled={values.statut !== 'EN_ATTENTE'}>
                                        <FaTrash />
                                    </Button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
            <Button color="primary" onClick={toggleChooseProductModal}
                disabled={values.statut !== 'EN_ATTENTE'}>
                <FaPlus /> {t('facture.addLine')}
            </Button>
            <Modal isOpen={chooseProductModal} toggle={toggleChooseProductModal} size="xl">
                <ModalHeader toggle={toggleChooseProductModal}>
                    {t('product.chooseProduct')}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={10}>
                            <Input
                                type="text"
                                placeholder={t('product.searchPlaceholder')}
                                value={modalSearchTerm}
                                onChange={handleModalSearchChange}
                                className="me-2" // Added margin to the right
                            />
                        </Col>
                        <Col md={2} className="text-end">
                            <Button color="primary" onClick={toggleProductModal} size="sm">
                                <FaPlus className="me-1" />
                                {t('product.new')}
                            </Button>
                        </Col>
                    </Row>
                    <DisplayToggle />
                    {displayMode === 'table' ? <TableView /> : <CardView />}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => {
                        setModalSearchTerm('');
                        setCurrentPage(1);
                        toggleChooseProductModal()
                    }}>
                        {t('common.cancel')}
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={productModal} toggle={toggleProductModal} size='xl'>
                <ModalHeader toggle={toggleProductModal}>
                    {t('product.createNew')}
                </ModalHeader>
                <ModalBody>
                    {error && (
                        <Toast className="position-fixed top-0 end-0 m-3" isOpen={true}>
                            <ToastHeader icon="danger" toggle={() => dispatch(productActions.clearError())} className="bg-danger text-white">
                                {t('common.error')}
                            </ToastHeader>
                            <ToastBody>{error}</ToastBody>
                        </Toast>)}
                    <FormikProvider value={formikp}>
                        <Row>
                            {/* Column 1 - Basic Information */}
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Code-barres</Label>
                                    <InputGroup>
                                        <Input
                                            name="codeBarre"
                                            value={values.codeBarre}
                                            onChange={formikp.handleChange}
                                        />
                                        <InputGroupText>
                                            <FaBarcode />
                                        </InputGroupText>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Libellé *</Label>
                                    <Input
                                        name="libelle"
                                        value={formikp.values.libelle}
                                        onChange={formikp.handleChange}
                                        invalid={formikp.touched.libelle && !!formikp.errors.libelle}
                                    />
                                    <FormFeedback>{formikp.errors.libelle}</FormFeedback>
                                </FormGroup>

                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Catégorie *</Label>
                                    <Select
                                        name="categorie"
                                        options={list.map(cat => ({ value: cat.id, label: cat.libelle }))}
                                        value={list.map(cat => ({ value: cat.id, label: cat.libelle }))
                                            .find(option => option.value === formikp.values.categorie) || null}
                                        onChange={(selected) => formikp.setFieldValue('categorie', selected ? selected.value : '')}
                                        placeholder="Rechercher une catégorie..."
                                        isClearable
                                        isSearchable
                                        className={formikp.touched.categorie && formikp.errors.categorie ? 'is-invalid' : ''}
                                    />
                                    {formikp.touched.categorie && formikp.errors.categorie && (
                                        <div className="text-danger small mt-1">{formikp.errors.categorie}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Unité *</Label>
                                    <Select
                                        name="unite"
                                        options={unites.map(unite => ({
                                            value: unite.code,
                                            label: `${unite.libelle} (${unite.code})`
                                        }))}
                                        value={unites.map(unite => ({
                                            value: unite.code,
                                            label: `${unite.libelle} (${unite.code})`
                                        })).find(option => option.value === formikp.values.unite) || null}
                                        onChange={(selected) => formikp.setFieldValue('unite', selected ? selected.value : '')}
                                        placeholder="Rechercher une unité..."
                                        isClearable
                                        isSearchable
                                        className={formikp.touched.unite && formikp.errors.unite ? 'is-invalid' : ''}
                                    />
                                    {formikp.touched.unite && formikp.errors.unite && (
                                        <div className="text-danger small mt-1">{formikp.errors.unite}</div>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                        <h5 className="mb-3">
                            <FaMoneyBillWave className="me-2" />
                            Prix de vente
                        </h5>
                        <Row>
                            <Col md={3}>

                                <FormGroup>
                                    <Label>Prix TTC (1) *</Label>
                                    <Input
                                        type="number"
                                        onFocus={(e) => e.target.select()} // Select the field content on focus
                                        name="prixVenteTTC1"
                                        value={formikp.values.prixVenteTTC1}
                                        onChange={formikp.handleChange}
                                        step="0.01"
                                        min="0"
                                        invalid={formikp.touched.prixVenteTTC1 && !!formikp.errors.prixVenteTTC1}
                                    />
                                    <FormFeedback>{formikp.errors.prixVenteTTC1}</FormFeedback>
                                    <small className="text-muted">
                                        Prix HT: {(formikp.values.prixVenteTTC1 / (1 + formikp.values.tauxTVAVente)).toFixed(2)} DH
                                    </small>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Label>Prix TTC (2)</Label>
                                    <Input
                                        type="number"
                                        onFocus={(e) => e.target.select()} // Select the field content on focus
                                        name="prixVenteTTC2"
                                        value={formikp.values.prixVenteTTC2}
                                        onChange={formikp.handleChange}
                                        step="0.01"
                                        min="0"
                                    />
                                    <small className="text-muted">
                                        Prix HT: {(formikp.values.prixVenteTTC2 / (1 + formikp.values.tauxTVAVente)).toFixed(2)} DH
                                    </small>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Label>Prix TTC (3)</Label>
                                    <Input
                                        type="number"
                                        onFocus={(e) => e.target.select()} // Select the field content on focus
                                        name="prixVenteTTC3"
                                        value={formikp.values.prixVenteTTC3}
                                        onChange={formikp.handleChange}
                                        step="0.01"
                                        min="0"
                                    />
                                    <small className="text-muted">
                                        Prix HT: {(formikp.values.prixVenteTTC3 / (1 + formikp.values.tauxTVAVente)).toFixed(2)} DH
                                    </small>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Label>TVA Vente (%)</Label>
                                    <Input
                                        type="select"
                                        name="tauxTVAVente"
                                        onChange={formikp.handleChange}
                                        value={formikp.values.tauxTVAVente}
                                    >
                                        {TVA_OPTIONS.map(option => (
                                            <option key={option.code} value={option.code}>
                                                {option.libelle}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="mt-4 pt-3 border-top">
                            <Button color="primary" disabled={formikp.isSubmitting} onClick={formikp.handleSubmit}>
                                {formikp.isSubmitting ? (
                                    <>
                                        <Spinner size="sm" /> Enregistrement...
                                    </>
                                ) : (
                                    <>
                                        <FaSave className="me-2" /> Enregistrer
                                    </>
                                )}
                            </Button>
                            <Button color="light" className="ms-2" onClick={toggleProductModal}>
                                <FaTimes className="me-2" /> Annuler
                            </Button>
                        </div>
                    </FormikProvider>
                </ModalBody>
            </Modal>

        </Container>
    );
};

export default ReceptionLines;